import axios from 'axios';
export const getTokenPassport = config => {
  return new Promise((resolve, reject) => {
    axios
      .get('/cgi-bin/transac/dotrxajax', {
        params: {
          TMPL: '/security/passport.json',
          intends: config.tokenIntends || 'TRXAML',
        },
      })
      .then(response => {
        resolve(response.data.token);
      })
      .catch(error => {
        reject(error);
      });
  });
};
const kycInstance = axios.create();
kycInstance.interceptors.request.use(
  config =>
    getTokenPassport(config)
      .then(tokenResponse => {
        config.headers.Authorization = `Bearer ${tokenResponse}`;
        return Promise.resolve(config);
      })
      .catch(error => {
        console.log(error);
      }),
  error => Promise.reject(error)
);
export default kycInstance;